import * as _ from 'lodash';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, RecipientActionCreators, IWaitlistImportUploadResponse, IWaitlistImportProcessResponse } from "@nkr/store/index";
import { IBaseResponse, IWaitListImportColumnMapping, IWaitlistImportItem, IWaitlistImportResults, IWaitListImportSampleRow } from '@nkr/models/index';
import { Component } from "react";
import { ProgressBar } from "react-bootstrap";
import ColumnMapping from "./step-2-column-mapping";
import UploadFile from "./step-1-upload-file";
import ReviewMappingResults from './step-3-review-mapping-results';
import { PatientsNotInFile } from './patients-not-in-file';
import { ExistingMatch } from './existing-match';
import { WaitlistImportStatus } from './waitlist-import-status';
import Complete from './step-4-complete';

interface IOwnProps {
    centerId: number
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    uploadWaitlistImportFile: (centerId: number, hasColumnHeaders: boolean, file: File) => Promise<IWaitlistImportUploadResponse>,
    processWaitlistImportFile: (centerId: number, hasColumnHeaders: boolean, autoOrderCheekSwabs: boolean, patientsNotInFile: number, existingMatch: number, mappedFields: string[], fileName: string) => Promise<IWaitlistImportProcessResponse>,
    applyWaitlistImportFile: (centerId: number, items: IWaitlistImportItem[], autoOrderCheekSwabs: boolean) => Promise<IBaseResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    step: number,
    fileWasUploaded: boolean,
    fileWasProcessed: boolean,
    headers: string[],
    sampleRows: IWaitListImportSampleRow[],
    columnMapping: IWaitListImportColumnMapping[],
    originalFileName: string,
    fileName: string,
    mappedFields: string[],
    mappedFieldsValid: boolean,
    hasColumnHeaders: boolean,
    autoOrderCheekSwabs: boolean,
    patientsNotInFile: PatientsNotInFile,
    existingMatch: ExistingMatch,
    previewResults: IWaitlistImportResults
}

class ImportWaitlist extends Component<TProps, IState> {
    readonly state: IState = {
        step: 1,
        fileWasUploaded: false, //__ENVIRONMENT__ == 'dev' ? true : false,
        fileWasProcessed: false,
        headers: [],
        sampleRows: [],
        columnMapping: [],
        originalFileName: '',
        fileName: '',
        mappedFields: [],
        mappedFieldsValid: true,
        hasColumnHeaders: false,
        autoOrderCheekSwabs: false,
        patientsNotInFile: 1,
        existingMatch: 1,
        previewResults: null
    }

    componentDidMount = () => {
        if (__ENVIRONMENT__ == 'dev2') {
            let columnMapping = [
                {
                    fieldName: "MRN",
                    fieldFromFile: "MRN",
                    isRequired: true
                },
                {
                    fieldName: "First Name",
                    fieldFromFile: "FirstName",
                    isRequired: true
                },
                {
                    fieldName: "Last Name",
                    fieldFromFile: "LastName",
                    isRequired: true
                },
                {
                    fieldName: "Email",
                    fieldFromFile: "Email",
                    isRequired: true
                },
                {
                    fieldName: "DOB",
                    fieldFromFile: "DateOfBirth",
                    isRequired: true
                },
                {
                    fieldName: "ABO",
                    fieldFromFile: "BloodType",
                    isRequired: true
                },
                {
                    fieldName: "Address",
                    fieldFromFile: "Address",
                    isRequired: false
                },
                {
                    fieldName: "City",
                    fieldFromFile: "City",
                    isRequired: false
                },
                {
                    fieldName: "State",
                    fieldFromFile: "State",
                    isRequired: false
                },
                {
                    fieldName: "Postal Code",
                    fieldFromFile: "PostalCode",
                    isRequired: false
                },
                {
                    fieldName: "Phone Number",
                    fieldFromFile: "PhoneNumber",
                    isRequired: false
                },
                {
                    fieldName: "Height",
                    fieldFromFile: "Height",
                    isRequired: false
                },
                {
                    fieldName: "Weight",
                    fieldFromFile: "Weight",
                    isRequired: false
                },
                {
                    fieldName: "Gender",
                    fieldFromFile: "Gender",
                    isRequired: false
                }
            ];

            this.setState({
                step: 2,
                headers: [
                    "recpid",
                    "MRN",
                    "FirstName",
                    "LastName",
                    "Email",
                    "DateOfBirth",
                    "BloodType",
                    "Address",
                    "City",
                    "State",
                    "PostalCode",
                    "PhoneNumber",
                    "Height",
                    "Weight",
                    "Gender"
                ],
                sampleRows: [
                    {
                        "lineNumber": 1,
                        "data": [
                            "15264",
                            "10509648",
                            "",
                            "",
                            "",
                            "1/1/1969",
                            "O",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "0",
                            "0",
                            ""
                        ]
                    },
                    {
                        "lineNumber": 2,
                        "data": [
                            "15232",
                            "15255628",
                            "Ramona",
                            "Demarco",
                            "",
                            "1/1/1957",
                            "O",
                            "1563 Walnut Ave",
                            "NORTH MERRICK",
                            "NY",
                            "11566",
                            "",
                            "0",
                            "0",
                            "F"
                        ]
                    },
                    {
                        "lineNumber": 3,
                        "data": [
                            "15229",
                            "15414835",
                            "",
                            "",
                            "",
                            "1/1/1981",
                            "B",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "0",
                            "0",
                            ""
                        ]
                    },
                    {
                        "lineNumber": 4,
                        "data": [
                            "15179",
                            "9317381",
                            "",
                            "",
                            "",
                            "1/1/1965",
                            "B",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "0",
                            "0",
                            ""
                        ]
                    },
                    {
                        "lineNumber": 5,
                        "data": [
                            "15106",
                            "15290131",
                            "",
                            "",
                            "",
                            "1/1/1984",
                            "A",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "0",
                            "0",
                            ""
                        ]
                    }
                ],
                columnMapping,
                fileName: '3e19db3f-c009-439b-990a-a7d264ac58f2.csv',
                mappedFields: true ? columnMapping.map(f => f.fieldFromFile) : columnMapping.map(x => ''),
                hasColumnHeaders: true
            });
        }
    }

    handleChangeStep = (step: number) => {
        this.setState({
            step
        });
    }

    handleFileUpload = (hasColumnHeaders: boolean, file: File) => {
        this.props.showLoading('Uploading & analyzing file, one moment please...').then(() => {
            this.props.uploadWaitlistImportFile(this.props.centerId, hasColumnHeaders, file)
                .then(response => {
                    if (response.data.success) {
                        let { headers, sampleRows, columnMapping, fileName } = response.data.results;

                        this.setState({
                            step: 2,
                            headers,
                            sampleRows,
                            columnMapping,
                            mappedFields: hasColumnHeaders ? columnMapping.map(f => f.fieldFromFile) : columnMapping.map(x => ''),
                            originalFileName: file.name,
                            fileName,
                            fileWasUploaded: true,
                            fileWasProcessed: false,
                            hasColumnHeaders,
                        });
                    }

                    this.props.hideLoading();
                })
                .catch(error => {
                    this.props.hideLoading();
                });
        });
    };

    handleHasColumnHeadersChanged = (hasColumnHeaders: boolean) => {
        this.setState({
            hasColumnHeaders,
            mappedFields: this.state.columnMapping.map(x => ''),
        });
    }

    handleAutoOrderCheekSwabsChange = (autoOrderCheekSwabs: boolean) => {
        let minimumRequiredFields = ['MRN', 'First Name', 'Last Name', 'Email', 'DOB', 'ABO'];

        let columnMapping = _.cloneDeep(this.state.columnMapping).map(x => {
            let isMinimumRequiredField = minimumRequiredFields.indexOf(x.fieldName) >= 0;

            if (!isMinimumRequiredField) {
                x.isRequired = autoOrderCheekSwabs;
            }

            return x;
        });

        this.setState({
            autoOrderCheekSwabs,
            columnMapping
        });
    }

    handlePatientsNotInFileChange = (patientsNotInFile: number) => {
        this.setState({
            patientsNotInFile
        });
    }

    handleExistingMatchChange = (existingMatch: number) => {
        this.setState({
            existingMatch
        });
    }

    handleMappedFieldsChange = (mappedFields: string[]) => {
        this.setState({
            mappedFields
        });
    }

    handleApplyMapping = () => {
        let { hasColumnHeaders, autoOrderCheekSwabs, patientsNotInFile, existingMatch, mappedFields, fileName } = this.state;

        this.props.showLoading('Processing file, one moment please...').then(() => {
            this.props.processWaitlistImportFile(this.props.centerId, hasColumnHeaders, autoOrderCheekSwabs, patientsNotInFile, existingMatch, mappedFields, fileName).then(response => {
                this.setState({
                    step: 3,
                    previewResults: response.data.results
                });

                this.props.hideLoading();
            });
        });
    }

    handleApplyFile = () => {
        let items = this.state.previewResults.items.filter(x => x.statusId != WaitlistImportStatus.Ignore && x.statusId != WaitlistImportStatus.Skip);

        this.props.showLoading('Applying changes, one moment please...').then(() => {
            this.props.applyWaitlistImportFile(this.props.centerId, items, this.state.autoOrderCheekSwabs).then(response => {
                this.setState({
                    step: 4
                });

                this.props.hideLoading();
            });
        });
    }

    handleImportAnotherFile = () => {
        this.setState({
            step: 1,
            fileWasUploaded: false, //__ENVIRONMENT__ == 'dev' ? true : false,
            fileWasProcessed: false,
            headers: [],
            sampleRows: [],
            columnMapping: [],
            originalFileName: '',
            fileName: '',
            mappedFields: [],
            mappedFieldsValid: true,
            hasColumnHeaders: false,
            autoOrderCheekSwabs: false,
            patientsNotInFile: 1,
            existingMatch: 1,
            previewResults: null
        });
    }

    renderProgress = () => {
        let steps = ['Upload File', 'Specify Mapping', 'Review Pending Results', 'Complete'];

        return (
            <ProgressBar>
                {steps.map((step, stepIndex) => {
                    return stepIndex == this.state.step - 1 ?
                        <ProgressBar active={(stepIndex + 1) >= this.state.step && (stepIndex + 1) < steps.length} max={steps.length} min={0} now={this.state.step} label={'Step ' + (stepIndex + 1) + ': ' + step} />
                        :
                        null;
                })}
            </ProgressBar>
        )
    }

    render = () => {
        return (
            <div className='container' style={{ padding: '0px 5px' }}>
                <div className='h3' style={{ marginBottom: 20 }}>Import Waitlist</div>

                {this.renderProgress()}

                {this.state.step == 1 && (
                    <UploadFile onUploadFile={this.handleFileUpload} />
                )}

                {this.state.step == 2 && (
                    <ColumnMapping
                        headers={this.state.headers}
                        sampleRows={this.state.sampleRows}
                        columnMapping={this.state.columnMapping}
                        mappedFields={this.state.mappedFields}
                        hasColumnHeaders={this.state.hasColumnHeaders}
                        autoOrderCheekSwabs={this.state.autoOrderCheekSwabs}
                        patientsNotInFile={this.state.patientsNotInFile}
                        existingMatch={this.state.existingMatch}
                        onHasColumnHeadersChange={this.handleHasColumnHeadersChanged}
                        onAutoOrderCheekSwabsChange={this.handleAutoOrderCheekSwabsChange}
                        onPatientsNotInFileChange={this.handlePatientsNotInFileChange}
                        onExistingMatchChange={this.handleExistingMatchChange}
                        onMappedFieldsChange={this.handleMappedFieldsChange}
                        onPreviousStep={() => this.handleChangeStep(1)}
                        onApply={this.handleApplyMapping}
                    />
                )}

                {this.state.step == 3 && (
                    <ReviewMappingResults
                        data={this.state.previewResults}
                        patientsNotInFile={this.state.patientsNotInFile}
                        columnMapping={this.state.columnMapping}
                        onPreviousStep={() => this.handleChangeStep(2)}
                        onProcessFile={this.handleApplyFile} />
                )}

                {this.state.step == 4 && (
                    <Complete
                        data={this.state.previewResults != null ? this.state.previewResults.items.filter(x => x.statusId != WaitlistImportStatus.Ignore && x.statusId != WaitlistImportStatus.Skip) : []}
                        onImportAnotherFile={this.handleImportAnotherFile}
                    />
                )}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        uploadWaitlistImportFile: (centerId, hasColumnHeaders, file) => {
            return dispatch(RecipientActionCreators.uploadWaitlistImportFile(centerId, hasColumnHeaders, file));
        },
        processWaitlistImportFile: (centerId, hasColumnHeaders, autoOrderCheekSwabs, patientsNotInFile, existingMatch, mappedFields, fileName) => {
            return dispatch(RecipientActionCreators.processWaitlistImportFile(centerId, hasColumnHeaders, autoOrderCheekSwabs, patientsNotInFile, existingMatch, mappedFields, fileName));
        },
        applyWaitlistImportFile: (centerId, items, autoOrderCheekSwabs) => {
            return dispatch(RecipientActionCreators.applyWaitlistImportFile(centerId, items, autoOrderCheekSwabs));
        }
    };
};

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    null,
    mapDispatchToProps)(ImportWaitlist);